export default "__VITE_ASSET__DIP$DUBv__"